import { cn } from "@/infrastructure/lib/utils";

type Props = {
  variant?: "auth" | "default" | "footer";
  className?: string;
};

export function GradientBackground({
  variant = "default",
  className,
}: Props) {
  const getGradientElements = () => {
    switch (variant) {
      case "auth":
        return (
          <>
            <div className="absolute -top-[200px] -left-[200px] h-[600px] w-[600px] rounded-full bg-warning opacity-30 blur-[200px]" />
            <div className="absolute -bottom-[250px] left-[20%] h-[700px] w-[700px] rounded-full bg-warning opacity-30 blur-[200px]" />
            <div className="absolute top-[100px] -right-[300px] h-[800px] w-[800px] rounded-full bg-brand-purple opacity-30 blur-[200px]" />
          </>
        );
      case "footer":
        return (
          <div className="absolute -bottom-[200px] left-1/2 h-[400px] w-[800px] -translate-x-1/2 transform rounded-full bg-warning/30 bg-warning/50 opacity-30 blur-[150px]" />
        );
      case "default":
      default:
        return (
          <>
            <div className="absolute -top-[100px] -left-[100px] h-[600px] w-[600px] rounded-full bg-primary/60 opacity-30 blur-[150px]" />
            <div className="absolute -bottom-[200px] left-[15%] h-[700px] w-[700px] rounded-full bg-accent/50 opacity-25 blur-[150px]" />
            <div className="absolute top-[200px] -right-[200px] h-[800px] w-[800px] rounded-full bg-secondary/60 opacity-30 blur-[150px]" />
          </>
        );
    }
  };

  return (
    <div
      className={cn(
        "pointer-events-none absolute inset-0 z-0 overflow-hidden",
        className
      )}
    >
      {getGradientElements()}
    </div>
  );
}
